import initSlickWithArrowEvent from "../components/slick-utils";

function initMaierCarouselPresentationSlider(slider) {
    let slick = initSlickWithArrowEvent(
        $(slider),
        {
            dots: false,
            arrows: true,
            prevArrow: '<span class="slide-arrow slide-arrow-white prev">Prev</span>',
            nextArrow: '<span class="slide-arrow slide-arrow-white next">Next</span>',
            autoplay: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false,
                        autoplay: false,
                        dots: true,
                        dotsClass: 'maier-carousel-presentation-dots'
                    }
                }
            ]
        }
    );

    slick.on('afterChange', function(event, slick, currentSlide) {
        var activeDotEl = $(event.target).find('.maier-carousel-presentation-dots').find('li.slick-active');
        if (activeDotEl.get(0)) {
            activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    });
}

function observeMaierCarouselPresentationSlider() {
    // IntersectionObserver
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initMaierCarouselPresentationSlider(entry.target);
                intersectionObserver.unobserve(entry.target);
            }
        });
    }, {rootMargin: '200px 0px'});

    document.querySelectorAll('.maier-carousel-presentation-list').forEach(slider => intersectionObserver.observe(slider));

    // MutationObserver
    const mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length >= 1) {
                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    if (undefined !== mutation.addedNodes[i].localName) {
                        mutation.addedNodes[i].querySelectorAll('.maier-carousel-presentation-list').forEach(slider => initMaierCarouselPresentationSlider(slider));
                    }
                }
                ;
            }
        });
    });

    mutationObserver.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });
}

function setupMaierCarouselPresentation() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            observeMaierCarouselPresentationSlider();
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMaierCarouselPresentation);
} else {
    setupMaierCarouselPresentation();
}